<template>
  <div class="videopage photopage">
    <v-menu></v-menu>
    <div class="pagebg">
    <div class="videoage resPage noticebox">
        <div class="page_title">公告</div>
        <div class="listbox" style="height:40rem;margin-bottom:3rem;">
          <ul v-if="newlists.length > 0">
           <li v-for="(item,index) in newlists" :key="index"><h3>{{item.content}}</h3><span>{{item.create_at}}</span></li>
          </ul>
          <div v-if="newlists.length == 0" class="nolist">
            <div class="nopic"><img src="../../../assets/images/nopic.png"></div>
            <p>暂无公告</p>
          </div>
        </div>
    </div>
      <!--<div class="videoage resPage">
        <div class="page_title">疑问/留言</div>
        <div class="form">
          <div class="put">
            <textarea placeholder="请输入您的问题" v-model="content"></textarea>
          </div>
          <div class="concat">
            <div class="left username">
              <input type="text" placeholder="请输入您的姓名" v-model="username"/>
            </div>
            <div class="right username email">
              <input type="text" placeholder="请输入您的邮箱" v-model="email"/>
            </div>
            <div class="clear clearfix"></div>
          </div>
          <div class="button" @click="sendForm">发送</div>
        </div>
      </div>-->
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        newlists:[],
        content:'',
        username:'',
        email:''
      }
    },
    mounted() {
      this.getlist()
    },
    methods: {
    // 公告列表
      getlist(){
      this.$http({
          url: '/Mail/newslist',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
          a:1
          }
        }).then((res) => {
          if(res.status==200){
          for(let i=0;i<res.data.data.length;i++){
            res.data.data[i].content.replace(/(\n)/g, "");
            res.data.data[i].content.replace(/(\t)/g, "");
            res.data.data[i].content.replace(/(\r)/g, "");
            res.data.data[i].content.replace(/<V?[^>]>/g, "");
            res.data.data[i].content.replace(/\s/g, "");
          }
          this.newlists = res.data.data
          }else{
            this.$layer.msg('发送失败')
          }
        })
        .catch((error) => {
          this.$layer.msg('网络错误，请稍后重试')
          console.log(error)
        })
      },
      sendForm(){
        if(!this.content){
          this.$layer.msg('请输入您的问题')
          return
        }
        if(!this.username){
          this.$layer.msg('请输入您的姓名')
          return
        }
        var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if(!reg.test(this.email)){
          this.$layer.msg('请输入正确的邮箱')
          return
        }
        this.$http({
          url: '/mail/index',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            subject:'',
            body:this.content,
            username:this.username,
            email:this.email
          }
        }).then((res) => {
          console.log(res)
          if(res.status==200){
            this.$layer.msg('发送成功')
            this.content=''
            this.username=''
            this.email=''
          }else{
            this.$layer.msg('发送失败')
          }
        })
        .catch((error) => {
          this.$layer.msg('网络错误，请稍后重试')
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  ::-webkit-scrollbar {
    width:2px;
  }
  .videoage{
    width:71rem;
    margin:0 auto 0;
    // height:100%;
  }
  .noticebox{
    .listbox{
      background-color: #fff;
      width: 100%;
      height: 30rem;
      border-radius: 0.3rem;
      box-sizing: border-box;
      padding: 0.3rem 2rem;
      ul{
        overflow-y: auto;
        width: 100%;
        height: 100%;
        li{
          padding: 0.8rem 0;
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          width: 100%;
          border-bottom: 0.1rem dashed #cda16d;
          line-height: 1.5;
          h3{
            flex: 1;
            font-size: 1.28rem;
            color: #624012;
            font-weight: 500;
          }
          span{
            text-align: right;
            width: 34%;
            font-size: 1rem;
            color: #624012;
          }
        }
      }
    }
  }
  .resPage{
    .page_title{
      font-size:2rem;
      color:#5f4009;
      line-height:2rem;
      font-weight: bold;
      padding:3.5rem 0 3rem;
    }
    .form{
      .put{
        width:100%;
        background: #fff;
        border-radius:4px;
        border:1px solid #ccac7d;
        textarea{
          width:100%;
          border-radius:4px;
          border:none;
          border:0;
          background: #fff;
          resize: none;
          height:28rem;
          display: block;
          box-sizing: border-box;
          padding:1rem;
          font-size:1.2rem;
        }
      }
      .concat{
        padding:2rem 0;
        .username{
          width:47%;
          height:3.7rem;
          border-radius:4px;
          border:1px solid #ccac7d;
          input{
            width:100%;
            border:none;
            border:0;
            border-radius:4px;
            height:100%;
            box-sizing: border-box;
            padding-left:1rem;
            font-size:1.2rem;
          }
        }
      }
      .button{
        width:100%;
        height:3.7rem;
        border-radius:4px;
        font-size:1.2rem;
        color:#fff;
        background:#c9a168;
        text-align: center;
        line-height: 3.7rem;
        cursor: pointer;
        margin-bottom:1.2rem;
      }
    }
    .nolist{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction:column;
      .nopic{
        width: 11rem;
        height: 8rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
      p{
        font-size: 1.2rem;
        color: #666;
        text-align: center;
        margin-top: 0.8rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/response/index.vue